import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Barcode from "react-barcode";
import { Card } from "react-bootstrap";
import { userProfileService } from "../service/userProfile/userProfile.service";
import loyaltyLogo from "../assets/images/loyalty.png";
import DynamicAlert from "../helpers/dynamicAlert";

export const LoyaltyPage = ({ loyaltyId, phoneNo, id, alert }) => {
    const [loyaltyNumber, setLoyaltyNumber] = useState(null);

    useEffect(() => {
        let isMounted = true;

        const fetchLoyaltyNumber = async () => {
            if (loyaltyId) {
                if (isMounted) setLoyaltyNumber(loyaltyId);
                return;
            }

            if (phoneNo && id) {
                try {
                    const data = await userProfileService.getLoyaltyNumber(
                        phoneNo,
                        id
                    );

                    if (data?.loyaltyNo && isMounted) {
                        setLoyaltyNumber(data.loyaltyNo);
                    }
                } catch (error) {
                    console.error("Error fetching loyalty number:", error);
                }
            }
        };

        fetchLoyaltyNumber();

        return () => {
            isMounted = false;
        };
    }, [loyaltyId, phoneNo, id]);

    const barcodeValue = loyaltyNumber || "0000000";

    const logoStyle = {
        width: "50%",
        maxWidth: "200px",
        height: "auto",
        marginBottom: "15px",
    };

    const barcodeWrapperStyle = {
        display: "flex",
        justifyContent: "center",
        overflowX: "auto",
        padding: "10px 0",
    };

    const textStyle = {
        fontSize: "1rem",
        marginBottom: "15px",
        color: "#555",
    };

    return (
        <div className="mfa-body">
            <div className="mfa-container">
                <div className="text-center m-6-auto">
                    <DynamicAlert alert={alert} />
                    <div className="p-1 py-2">
                        <div className="text-center m-6-auto section-title">
                            <h4>Loyalty Card</h4>
                        </div>
                    </div>

                    <Card.Text style={textStyle}>
                        With MyThyme it's your time to shop and save!
                    </Card.Text>

                    <img
                        src={loyaltyLogo}
                        alt="MyThyme Loyalty: Real Rewards"
                        style={logoStyle}
                    />

                    {barcodeValue && (
                        <div style={barcodeWrapperStyle}>
                            <Barcode
                                value={barcodeValue}
                                format="CODE128"
                                width={2}
                                height={50}
                                displayValue
                                font="monospace"
                                textAlign="center"
                                textPosition="bottom"
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};


LoyaltyPage.propTypes = {
    loyaltyId: PropTypes.string,
    phoneNo: PropTypes.string,
    id: PropTypes.string,
    alert: PropTypes.object,
};

export default LoyaltyPage;